<template>
  <div id="wrapper" class="page">
    <div id="content-wrapper" style="height: 100%;">
      <div class="container-fluid">
        <!-- <b-row class="ml-auto">

        </b-row> -->

        <b-row class="ml-auto">
          <!-- Cot trai -->
          <b-col cols="4">
            <!-- THONG KE NHAN SU -->
            <b-row>
              <b-card
                border-variant="light"
                header="THỐNG KÊ NHÂN SỰ"
                header-border-variant="light"
                style="width: 100%"
                align="center"
              >
                <!-- 1. 2. Nhan su tang giam -->
                <b-row>
                  <b-card-group columns style="width: 100%">
                    <b-card align="center">
                      <b-row class="ml-md-mr-auto">
                        <b-col cols="2">
                          <div class="card-icon-i">
                            <i class="fas fa-arrow-up"></i>
                          </div>
                        </b-col>
                        <b-col cols="10">
                          <div class="card-icon-body">
                            <b-card-text class="text-center">
                              <h3>{{ dashboards[0].content }}</h3>
                              <span style="font-size: 25px;">
                                <b-badge variant="success" class="mr-2"
                                  >{{ dashboards[0].count }}
                                </b-badge>
                                <i class="fas fa-male"></i>
                              </span>
                            </b-card-text>
                          </div>
                        </b-col>
                      </b-row>
                    </b-card>
                    <b-card class="ml-md-auto">
                      <b-row class="ml-md-mr-auto">
                        <b-col cols="2">
                          <div class="card-icon-i">
                            <!-- style="color:red;" -->
                            <i class="fas fa-arrow-down"></i>
                          </div>
                        </b-col>
                        <b-col cols="10">
                          <div class="card-icon-body">
                            <b-card-text class="text-center">
                              <h3>{{ dashboards[1].content }}</h3>
                              <span style="font-size: 25px;">
                                <b-badge variant="danger" class="mr-2"
                                  >{{ dashboards[1].count }}
                                </b-badge>
                                <i class="fas fa-male"></i>
                              </span>
                            </b-card-text>
                          </div>
                        </b-col>
                      </b-row>
                    </b-card>
                  </b-card-group>
                </b-row>

                <!-- 3. 4. Nhan vien qua han -->
                <b-row>
                  <b-card-group columns style="width: 100%">
                    <b-card align="center">
                      <b-row class="ml-md-mr-auto">
                        <b-col cols="2">
                          <div class="card-icon-i">
                            <i class="fas fa-calendar-times"></i>
                          </div>
                        </b-col>
                        <b-col cols="10">
                          <div class="card-icon-body">
                            <b-card-text class="text-center">
                              <h3>{{ dashboards[2].content }}</h3>
                              <span style="font-size: 25px;">
                                <b-badge variant="warning" class="mr-2"
                                  >{{ dashboards[2].count }}
                                </b-badge>
                                <i class="fas fa-male"></i>
                              </span>
                            </b-card-text>
                          </div>
                        </b-col>
                      </b-row>
                    </b-card>
                    <b-card class="ml-md-auto">
                      <b-row class="ml-md-mr-auto">
                        <b-col cols="2">
                          <div class="card-icon-i">
                            <!-- style="color:red;" -->
                            <i class="fas fa-calendar-minus"></i>
                          </div>
                        </b-col>
                        <b-col cols="10">
                          <div class="card-icon-body">
                            <b-card-text class="text-center">
                              <h3>{{ dashboards[3].content }}</h3>
                              <span style="font-size: 25px;">
                                <b-badge variant="warning" class="mr-2"
                                  >{{ dashboards[3].count }}
                                </b-badge>
                                <i class="fas fa-male"></i>
                              </span>
                            </b-card-text>
                          </div>
                        </b-col>
                      </b-row>
                    </b-card>
                  </b-card-group>
                </b-row>

                <!-- 5. 6. Sap het han hop dong 30 ngay/60 ngay -->
                <b-row>
                  <b-card-group columns style="width: 100%">
                    <b-card align="center">
                      <b-row class="ml-md-mr-auto">
                        <b-col cols="2">
                          <div class="card-icon-i">
                            <i class="fas fa-file-alt"></i>
                          </div>
                        </b-col>
                        <b-col cols="10">
                          <div class="card-icon-body">
                            <b-card-text class="text-center">
                              <h3>{{ dashboards[4].content }}</h3>
                              <span style="font-size: 25px;">
                                <b-badge variant="secondary" class="mr-2"
                                  >{{ dashboards[4].count }}
                                </b-badge>
                                <i class="fas fa-male"></i>
                              </span>
                            </b-card-text>
                          </div>
                        </b-col>
                      </b-row>
                    </b-card>
                    <b-card class="ml-md-auto">
                      <b-row class="ml-md-mr-auto">
                        <b-col cols="2">
                          <div class="card-icon-i">
                            <!-- style="color:red;" -->
                            <i class="fas fa-file-alt"></i>
                          </div>
                        </b-col>
                        <b-col cols="10">
                          <div class="card-icon-body">
                            <b-card-text class="text-center">
                              <h3>{{ dashboards[5].content }}</h3>
                              <span style="font-size: 25px;">
                                <b-badge variant="secondary" class="mr-2"
                                  >{{ dashboards[5].count }}
                                </b-badge>
                                <i class="fas fa-male"></i>
                              </span>
                            </b-card-text>
                          </div>
                        </b-col>
                      </b-row>
                    </b-card>
                  </b-card-group>
                </b-row>

                <!-- 7. Sinh nhật -->
                <b-row>
                  <b-col cols="3"> </b-col>
                  <b-col cols="9">
                    <b-card-group columns style="width: 100%">
                      <b-card align="center">
                        <b-row class="ml-md-mr-auto">
                          <b-col cols="2">
                            <div class="card-icon-i">
                              <i class="fas fa-birthday-cake"></i>
                            </div>
                          </b-col>
                          <b-col cols="10">
                            <div class="card-icon-body">
                              <b-card-text class="text-center">
                                <h3>{{ dashboards[6].content }}</h3>
                                <span style="font-size: 25px;">
                                  <b-badge variant="info" class="mr-2"
                                    >{{ dashboards[6].count }}
                                  </b-badge>
                                  <i class="fas fa-male"></i>
                                </span>
                              </b-card-text>
                            </div>
                          </b-col>
                        </b-row>
                      </b-card>
                    </b-card-group>
                  </b-col>
                </b-row>
              </b-card>
            </b-row>

            <!-- CÔNG VIỆC -->
            <b-row>
              <b-card
                class="mt-3"
                header="CÔNG VIỆC ĐANG THỰC HIỆN"
                border-variant="light"
                header-border-variant="light"
                style="width: 100%"
                align="center"
              >
                <b-table
                  thead-class="d-none"
                  bordered
                  head-variant="dark"
                  hover
                  responsive
                  striped
                  small
                  table-variant="light"
                  header-class="font-weight-bold"
                  :fields="taskFields"
                  :items="taskItems"
                  style="overflow: auto;height: 200px;"
                >
                  <template #cell(STT)="data">
                    {{ data.index + 1 }}
                  </template>
                  <template v-slot:cell(status)="data">
                    <b-badge variant="warning" v-if="data.value == 0">
                      <b>Chưa bắt đầu</b>
                    </b-badge>
                    <b-badge variant="info" v-if="data.value == 1">
                      <b>Đang thực hiện</b>
                    </b-badge>
                    <!-- Hoàn thành màu xanh lá cây  -->
                    <b-badge variant="success" v-if="data.value == 2">
                      <b>Hoàn thành</b>
                    </b-badge>
                  </template>
                  <template v-slot:cell(tienDo)="data">
                    <b-badge variant="danger" v-if="data.value == 1">
                      <b>Quá hạn</b>
                    </b-badge>
                    <b-badge variant="danger" v-else-if="data.value == 2">
                      <b>Trễ hạn</b>
                    </b-badge>
                    <b-badge variant="success" v-else-if="data.value == 3">
                      <b>Đúng hạn</b>
                    </b-badge>
                    <b-badge variant="danger" v-else-if="data.value == 0">
                    </b-badge>
                  </template>
                </b-table>
              </b-card>
            </b-row>
            <!-- END OF CONG VIEC -->

            <!-- HOP DONG -->
            <b-row>
              <b-card
                class="mt-3"
                header="HỢP ĐỒNG"
                border-variant="light"
                header-border-variant="light"
                style="width: 100%;"
                align="center"
              >
                <b-table
                  bordered
                  head-variant="dark"
                  hover
                  responsive
                  striped
                  small
                  table-variant="light"
                  header-class="font-weight-bold"
                  :fields="contract_fields"
                  :items="contract_items"
                  style="overflow: auto;"
                >
                  <template v-slot:cell(tieude)="data">
                    <b v-if="data.item.tinhtrang == '#*HEADER@&!'">{{
                      data.item.tieude
                    }}</b>
                    <div v-else>{{ data.item.tieude }}</div>
                  </template>
                  <template v-slot:cell(sotien)="data">
                    <div v-if="data.item.tinhtrang == '#*HEADER@&!'" />
                    <b v-else>{{ data.item.sotien | numeral("0,0") }}</b>
                  </template>
                  <template v-slot:cell(ngaynhandukien)="data">
                    <div v-if="data.item.tinhtrang == '#*HEADER@&!'" />
                    <div v-else>
                      <b-badge v-if="data.index < insert_index" variant="info3">
                        {{ data.item.ngaynhandukien | moment("DD/MM/YYYY") }}
                      </b-badge>
                      <b-badge v-else variant="danger3">
                        {{ data.item.ngaynhandukien | moment("DD/MM/YYYY") }}
                      </b-badge>
                    </div>
                  </template>
                </b-table>
              </b-card>
            </b-row>
            <!-- END OF HOP DONG -->
          </b-col>

          <!-- Cot phai -->
          <b-col cols="8">
            <b-card
              border-variant="light"
              header=""
              header-border-variant="primary"
              align="center"
            >
              <b-tabs content-class="mt-3">
                <b-tab title="BOOKING" active>
                  <div class="mydiv">
                    <b-row class="">
                      <b-col
                        style="width:80px; min-width:80px;  max-width:80px; padding-right: 0px;padding-left: 0px;"
                      >
                        <button
                          class="btn-sm btn-outline-secondary border-0 float-left"
                          style="padding-top:1px; padding-bottom:1px; background-color: #fde3c1;"
                          @click.prevent="$refs.booking_vuecal.previous()"
                        >
                          <i
                            style="font-size: 31px !important;"
                            class="fas fa-angle-left"
                          ></i>
                        </button>
                      </b-col>
                      <b-col
                        style="flex-grow: 1; font-size: 20px; font-weight: bold;"
                        class="text-center"
                      >
                        {{ $convert_date_string_master(this.startDate) }}
                      </b-col>
                      <b-col
                        style="width:80px; min-width:80px;  max-width:80px; padding-right: 0px;padding-left: 0px;"
                      >
                        <button
                          class="btn-sm btn-outline-secondary border-0 float-right"
                          style="padding-top:1px; padding-bottom:1px; background-color: #fde3c1;"
                          @click.prevent="$refs.booking_vuecal.next()"
                        >
                          <i
                            style="font-size: 31px !important;"
                            class="fas fa-angle-right"
                          ></i>
                        </button>
                        <button
                          class="btn-sm btn-outline-secondary border-0 float-right"
                          style="padding-top:4px; padding-bottom:3px; background-color: #fde3c1; margin-right:3px;"
                          @click.prevent="
                            $refs.booking_vuecal.switchView('month', new Date())
                          "
                        >
                          <i
                            style="font-size: 25px !important;"
                            class="fas fa-map-marker-alt "
                          ></i>
                        </button>
                      </b-col>
                    </b-row>
                  </div>
                  <vue-cal
                    ref="booking_vuecal"
                    hide-title-bar
                    today-button
                    locale="en"
                    @ready="viewChange"
                    @view-change="viewChange"
                    :active-view.sync="activeView"
                    events-on-month-view="short"
                    hide-view-selector
                    :disable-views="['years', 'year']"
                    :time-from="8 * 60"
                    :time-to="20 * 60"
                    :events="meeting_events"
                    :time-step="30"
                    id="booking_vuecal"
                  >
                    <template v-slot:split-label="{ split }">
                      <i class="far fa-building"></i>
                      <strong>{{ split.label }}</strong>
                    </template>
                    <template v-slot:cell-content="{ cell }">
                      <span
                        class="vuecal__cell-date m-1"
                        :style="{
                          color:
                            cell.class == 'vuecal__cell--day6' ||
                            cell.class == 'vuecal__cell--day7'
                              ? cell.outOfScope != true
                                ? '#ffb284'
                                : '#ffb38280'
                              : '',
                        }"
                        ><div>
                          {{ cell.content }}
                        </div>
                      </span>
                    </template>
                    <template v-slot:weekday-heading="{ heading }">
                      <div
                        style="font-weight:bold; width: 100%; border-radius:3px; "
                        :style="change_weekdays_headings_color(heading.label)"
                      >
                        {{ heading.label.substring(0, 3) }}
                      </div>
                    </template>
                    <template v-slot:no-event>{{&nbsp;}}</template>
                    <template v-slot:event="{ event }">
                      <div
                        style="width: 100%; height: 100%; color: #000;"
                        :style="[
                          event.status == 0
                            ? {
                                'border-style': 'solid',
                                'border-width': '5px',
                                'border-color': event.color,
                              }
                            : {
                                'border-style': 'solid',
                                'border-width': '5px',
                                'background-color': event.color,
                                'border-color': event.color,
                              },
                        ]"
                      >
                        <div
                          class="vuecal__event-title"
                          v-html="
                            findMeeting(event.meetingId) + ': ' + event.title
                          "
                        />

                        <div class="vuecal__event-time">
                          <span
                            v-if="
                              findMeeting(event.meetingId) == 'Van - 16 seats'
                            "
                          >
                            <img
                              src="../assets/icon_Van.png"
                              height="19px"
                              width="28px"
                              style="float:left"
                            />
                            {{ event.start | moment("HH:mm") }} -
                            {{ event.end | moment("HH:mm") }}
                          </span>

                          <span
                            v-else-if="
                              findMeeting(event.meetingId) == 'Innova - 7 seats'
                            "
                          >
                            <img
                              src="../assets/icon_Innova.png"
                              height="17px"
                              width="28px"
                              style="float:left"
                            />
                            {{ event.start | moment("HH:mm") }} -
                            {{ event.end | moment("HH:mm") }}
                          </span>

                          <span
                            v-else-if="
                              findMeeting(event.meetingId) == 'Meeting Room'
                            "
                          >
                            <img
                              src="../assets/icon_Meeting.png"
                              height="17px"
                              width="28px"
                              style="float:left"
                            />
                            {{ event.start | moment("HH:mm") }} -
                            {{ event.end | moment("HH:mm") }}
                          </span>

                          <span
                            v-else-if="
                              findMeeting(event.meetingId) ==
                                'Fitting & Casting Area'
                            "
                          >
                            <img
                              src="../assets/icon_FittingCasting.png"
                              height="17px"
                              width="28px"
                              style="float:left"
                            />
                            {{ event.start | moment("HH:mm") }} -
                            {{ event.end | moment("HH:mm") }}
                          </span>

                          <span
                            v-else-if="
                              findMeeting(event.meetingId) == 'Present Room 1'
                            "
                          >
                            <img
                              src="../assets/icon_Present.png"
                              height="17px"
                              width="28px"
                              style="float:left"
                            />
                            {{ event.start | moment("HH:mm") }} -
                            {{ event.end | moment("HH:mm") }}
                          </span>

                          <span
                            v-else-if="
                              findMeeting(event.meetingId) == 'Present Room 2'
                            "
                          >
                            <img
                              src="../assets/icon_Present.png"
                              height="17px"
                              width="28px"
                              style="float:left"
                            />
                            {{ event.start | moment("HH:mm") }} -
                            {{ event.end | moment("HH:mm") }}
                          </span>

                          <span v-else>
                            {{ event.start | moment("HH:mm") }} -
                            {{ event.end | moment("HH:mm") }}
                          </span>
                        </div>
                      </div>
                    </template>
                  </vue-cal>
                </b-tab>
                <b-tab title="CÔNG VIỆC">
                  <div class="mydiv">
                    <b-row class="">
                      <b-col
                        style="width:80px; min-width:80px;  max-width:80px; padding-right: 0px;padding-left: 0px;"
                      >
                        <button
                          class="btn-sm btn-outline-secondary border-0 float-left"
                          style="padding-top:1px; padding-bottom:1px; background-color: #fde3c1;"
                          @click.prevent="$refs.cong_viec.previous()"
                        >
                          <i
                            style="font-size: 31px !important;"
                            class="fas fa-angle-left"
                          ></i>
                        </button>
                      </b-col>
                      <b-col
                        style="flex-grow: 1; font-size: 20px; font-weight: bold;"
                        class="text-center"
                      >
                        {{ $convert_date_string_master(this.startDateTask) }}
                      </b-col>
                      <b-col
                        style="width:80px; min-width:80px;  max-width:80px; padding-right: 0px;padding-left: 0px;"
                      >
                        <button
                          class="btn-sm btn-outline-secondary border-0 float-right"
                          style="padding-top:1px; padding-bottom:1px; background-color: #fde3c1;"
                          @click.prevent="$refs.cong_viec.next()"
                        >
                          <i
                            style="font-size: 31px !important;"
                            class="fas fa-angle-right"
                          ></i>
                        </button>
                        <button
                          class="btn-sm btn-outline-secondary border-0 float-right"
                          style="padding-top:4px; padding-bottom:3px; background-color: #fde3c1; margin-right:3px;"
                          @click.prevent="
                            $refs.cong_viec.switchView('month', new Date())
                          "
                        >
                          <i
                            style="font-size: 25px !important;"
                            class="fas fa-map-marker-alt "
                          ></i>
                        </button>
                      </b-col>
                    </b-row>
                  </div>
                  <vue-cal
                    ref="cong_viec"
                    today-button
                    hide-title-bar
                    hide-view-selector
                    :disable-views="['years', 'year']"
                    locale="en"
                    :time-from="8 * 60"
                    :time-to="20 * 60"
                    :events="task_calendar_events"
                    :time-step="30"
                    @ready="viewChangeTask"
                    @view-change="viewChangeTask"
                    :active-view.sync="activeView"
                    events-on-month-view="short"
                    id="cong_viec_vuecal"
                  >
                    <template v-slot:split-label="{ split }">
                      <i class="far fa-building"></i>
                      <strong>{{ split.label }}</strong>
                    </template>
                    <template v-slot:cell-content="{ cell }">
                      <span
                        class="vuecal__cell-date m-1"
                        :style="{
                          color:
                            cell.class == 'vuecal__cell--day6' ||
                            cell.class == 'vuecal__cell--day7'
                              ? cell.outOfScope != true
                                ? '#ffb284'
                                : '#ffb38280'
                              : '',
                        }"
                        ><div>
                          {{ cell.content }}
                        </div>
                      </span>
                    </template>
                    <template v-slot:weekday-heading="{ heading }">
                      <div
                        style="font-weight:bold; width: 100%; border-radius:3px; "
                        :style="change_weekdays_headings_color(heading.label)"
                      >
                        {{ heading.label.substring(0, 3) }}
                      </div>
                    </template>
                    <template v-slot:no-event>{{&nbsp;}}</template>
                    <template v-slot:event="{ event }">
                      <div
                        style="width: 100%; height: 100%; color: #000;"
                        :style="taskEventStatus(event)"
                      >
                        <div class="vuecal__event-title" v-html="event.title" />
                        <div class="vuecal__event-time">
                          <i v-if="event.important == 1" class="fas fa-flag" />
                          <i
                            v-if="event.label == 1"
                            class="fas fa-calendar-alt"
                          />
                        </div>
                      </div>
                    </template>
                  </vue-cal>
                </b-tab>
              </b-tabs>
            </b-card>
          </b-col>
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import VueCal from "vue-cal";
import "vue-cal/dist/i18n/vi.js";
import "vue-cal/dist/vuecal.css";
//import ContractSideBar from "../components/Contract/ContractSideBar";
// import MyDatePicker from "../components/App/MyDatePicker.vue";

export default {
  name: "Dashboard",
  props: {
    msg: String,
  },
  components: {
    VueCal,
    //VueDatepickerLocal,
  },
  data() {
    return {
      // employeeDashboardFields: [
      //   {
      //     key: "STT",
      //     label: "STT",
      //     tdClass: "text-center",
      //     thClass: "align-middle",
      //     thStyle: { width: "10px", textAlign: "center" },
      //   },
      //   {
      //     key: "content",
      //     label: "Nội dung",
      //     tdClass: "text-left",
      //     thClass: "align-middle",
      //     thStyle: { textAlign: "center" },
      //   },
      //   {
      //     key: "total",
      //     label: "Số lượng",
      //     thClass: "align-middle",
      //     thStyle: { width: "80px", textAlign: "center" },
      //     tdClass: "text-right",
      //   },
      // ],
      taskFields: [
        {
          key: "STT",
          label: "STT",
          thClass: "align-middle",
          thStyle: { textAlign: "center" },
        },
        {
          key: "name",
          label: "Công việc",
          tdClass: "text-left",
          thClass: "align-middle",
          thStyle: { textAlign: "center" },
        },
        // {
        //   key: "status",
        //   label: "Tình trạng"
        // },
        // {
        //   key: "tienDo",
        //   label: "Tiến độ"
        // },
      ],
      contract_fields: [
        {
          key: "tieude",
          label: "Dự án",
          tdClass: "text-left",
          sortable: true,
          thClass: "align-middle",
          thStyle: { textAlign: "center" },
        },
        {
          key: "sotien",
          label: "Phải thanh toán",
          tdClass: "text-right",
          sortable: true,
          thClass: "align-middle",
          thStyle: { textAlign: "center" },
        },
        {
          key: "ngaynhandukien",
          label: "Thời hạn",
          tdClass: "text-right",
          sortable: true,
          thClass: "align-middle",
          thStyle: { textAlign: "center" },
        },
      ],
      taskItems: [],
      // employeeDashboards: [
      //     { content: "Thiết kế website", total: 1},
      //     { content: "Thiết kế logo", total: 2},
      //     { content: "Thiết kế banner"},
      //     { content: "Gặp khách hàng VINHOME"},
      dashboards: [{}, {}, {}, {}, {}, {}, {}],

      //     // { STT: 1, content: "Nhân viên tăng trong tháng", total: 1},
      //     // { STT: 2, content: "Nhân viên giảm trong tháng", total: 2},
      //     // { STT: 3, content: "Nhân viên hết hạn thử việc:"},
      //     // { STT: 4, content: "Nhân viên đến hạn tăng lương:"},
      //     // { STT: 5, content: "Hợp đồng sắp hết hạn 60 ngày:"},
      //     // { STT: 6, content: "Hợp đồng sắp hết hạn 30 ngày"},
      //     // { STT: 7, content: "Sinh nhật"},
      // ],

      meetings: [],
      tasks: [],
      // dashboards: [],
      task_calendar_events: [],
      contract_items: [
        { id: -1, tieude: "Chưa tới hạn thanh toán", tinhtrang: "#*HEADER@&!" },
        { id: -1, tieude: "Qúa hạn thanh toán", tinhtrang: "#*HEADER@&!" },
      ],

      activeView: "month",
      meeting_events: [],
      insert_index: 1,
      startDate: null,
      endDate: null,
      startDateTask: null,
      endDateTask: null,
    };
  },
  beforeRouteEnter(to, from, next) {
    axios
      .all([
        axios.get("/api/dashboard"),
        axios.get("/api/meeting/use"),
        axios.get("/api/task/dashboard"),
        axios.get("/api/dashboard/customercontract"),
      ])
      .then(
        axios.spread((dashboard, meeting, task, customercontract) => {
          next((vm) =>
            vm.initData(
              dashboard.data.items,
              meeting.data,
              task.data,
              customercontract.data.under,
              customercontract.data.over
            )
          );
        })
      );
  },
  methods: {
    initData(dashboards, meetings, tasks, contract_unders, contract_overs) {
      this.dashboards = dashboards;
      this.meetings = meetings;
      this.taskItems = tasks;
      for (let contract of contract_unders) {
        this.contract_items.splice(this.insert_index++, 0, contract);
      }
      for (let contract of contract_overs) {
        this.contract_items.push(contract);
      }
    },
    findMeeting(id) {
      const temp = this.meetings.find(function(el) {
        if (el.id == id) return el;
      });
      return temp == null ? "" : temp.name;
    },
    viewChange(obj) {
      this.startDate = obj.startDate;
      this.endDate = obj.endDate;
      this.getEvents(this.meetings);
    },
    viewChangeTask(obj) {
      this.startDateTask = obj.startDate;
      this.endDateTask = obj.endDate;
      this.getEventsTask();
    },
    getEvents(meetings) {
      let meetingid = "";
      for (let i = 0; i < meetings.length; i++) {
        if (i != 0) meetingid += ",";
        meetingid += meetings[i].id;
      }

      axios
        .get("/api/meetingevent", {
          params: {
            meetingid: meetingid,
            start: this.startDate.getTime(),
            end: this.endDate.getTime(),
          },
        })
        .then((response) => {
          this.meeting_events = response.data;
        })
        .catch((err) => {
          this.$toast.error(err.response.data, "Error", { timeout: 3000 });
        });
    },
    getEventsTask() {
      axios
        .get("/api/task/dashboard_calendar", {
          params: {
            start: this.startDateTask.getTime(),
            end: this.endDateTask.getTime(),
          },
        })
        .then((response) => {
          this.task_calendar_events = response.data;
        })
        .catch((err) => {
          this.$toast.error(err.response.data, "Error", { timeout: 3000 });
        });
    },
    taskEventStatus(event) {
      if (event.status == 0)
        return {
          "border-style": "solid",
          "border-width": "5px",
          "border-color": "##FF0000",
        };
      if (event.status == 1)
        return {
          "border-style": "solid",
          "border-width": "5px",
          "border-color": "#20B2AA",
        };
      if (event.status == 2)
        return {
          "border-style": "solid",
          "border-width": "5px",
          "border-color": "#20B2AA",
          "background-color": "#20B2AA",
        };
    },
    change_weekdays_headings_color(day_name) {
      if (day_name == "Sunday" || day_name == "Saturday") {
        return { "background-color": "#ffb284" };
      } else {
        return { "background-color": "#ffd18b" };
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import url("https://fonts.googleapis.com/css?family=Montserrat");
@import url("https://fonts.googleapis.com/icon?family=Material+Icons");

.card-card_title {
  font-size: 2em !important;
  font-weight: 500 !important;
  text-shadow: 2px 2px #333 !important;
  font-size: 100px;
}
.card-header {
  font-size: 18px;
  font-weight: bold !important;
  font-family: "Montserrat", sans-serif !important;
}
.card-card_footer {
  font-size: 2em;
  font-weight: 500;
  text-shadow: 2px 2px #333;
}
.dashboard {
  display: flex;
  flex-wrap: wrap;
}

.card-icon {
  flex: 1 1 18%;
  background: #ffffff;
  border-radius: 6px;
  border: 1px solid #deebfd;
  box-shadow: 0 3px 10px rgba(62, 85, 120, 0.045);
  margin: 0 8px 30px;
}

.card-icon .card-icon-body {
  padding: 20px;
}

.card-icon-i {
  width: 60px;
  height: 60px;
  border-radius: 60%;
  background-color: #e5f2f4;
  margin: 0 auto;
  position: relative;
}

.card-icon .card-icon-body h3 {
  text-align: center;
  margin-bottom: 0;
  margin-top: 10px;
  font-size: 18px;
  font-weight: 400;
  color: #212529;
}

.card-icon-i i {
  top: 50%;
  text-align: center;
  position: absolute;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 35px;
  /* Mau cua icon */
  color: #0c68b4;
}

.table {
  flex: 0 1 58%;
  background: #ffffff;
  border-radius: 6px;
  border: 1px solid #deebfd;
  box-shadow: 0 3px 10px rgba(62, 85, 120, 0.045);
  margin: 0 8px 30px;
}

.table-responsive {
  display: block;
  width: 100%;
  overflow-x: auto;
}

.table .table-head {
  border-bottom: 1px solid #eee;
  padding: 0 15px;
}

.table .table-body {
  padding: 25px;
}

.table .table-body table {
  width: 100%;
  border-collapse: collapse;
}

.table table thead tr th {
  padding: 0 10px;
  height: 50px;
  vertical-align: middle;
  color: #666;
  font-weight: 500;
  border-bottom-color: #e2e8f0;
  background-color: #f7f8f9;
  border-top-width: 1px;
  border-bottom-width: 1px;
}

.table tbody tr td,
.table tbody tr th {
  padding: 10px;
  border-bottom: 1px solid #eee;
  vertical-align: middle;
  font-size: 14px;
  color: #212529;
  text-align: center;
}

.btn-group {
  display: flex;
  align-items: center;
  justify-content: center;
}

.btn-group a {
  padding: 3px;
  width: 26px;
  height: 26px;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
  margin: 0 5px;
  color: #fff;
  background-color: #0c68b4;
  border-color: #0c68b4;
  border-radius: 0.375rem;
  font-weight: 500;
}

.btn-group a {
  text-align: center;
  line-height: 25px;
  display: block;
}

@media only screen and (max-width: 768px) {
  .table {
    flex: 1 1 100%;
    overflow-x: scroll;
  }
}

.cards {
  flex: 1 1 34%;
  flex-wrap: wrap;
}

.card2 {
  border-radius: 6px;
  border: 1px solid #deebfd;
  box-shadow: 0 3px 10px rgba(62, 85, 120, 0.045);
  margin: 0 8px 10px;
  position: relative;
  background-color: #0c68b4;
  height: 94px;
  padding: 20px;
}

.card .icon {
  color: rgba(0, 0, 0, 0.1);
  position: absolute;
  right: 38px;
  bottom: 69px;
  z-index: 1;
}

.card .icon i {
  font-size: 100px;
  line-height: 0;
  margin: 0;
  padding: 0;
  vertical-align: bottom;
}

.card .num,
.card h3 {
  position: relative;
  color: #fff;
  z-index: 5;
  margin: 0;
  padding: 0;
}

.card .num {
  font-size: 50px;
  font-weight: bold;
}

.card h3 {
  /* margin-top: 10px; */
  font-size: 20px;
  margin-left: 5px;
  color: #212529;
}

.badge {
  /* padding: 1px 9px 2px; */
  font-size: 13.025px;
  font-weight: bold;
  white-space: nowrap;
  background-color: #999999;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  border-radius: 5px;
}
.badge-success {
  color: #383838;
  background-color: #c0f7fe;
}
.badge-success:hover {
  color: #383838;
  background-color: #c0f7fe;
}
.badge-primary {
  color: #383838;
  background-color: #ffffd7;
}
.badge-primary:hover {
  color: #383838;
  background-color: #ffffd7;
}

.badge-info {
  color: #383838;
  background-color: #ffe1c6;
}
.badge-info:hover {
  color: #383838;
  background-color: #ffe1c6;
}

.badge-warning {
  color: #ffffff;
  background-color: #fc8b28;
}
.badge-warning:hover {
  color: #ffffff;
  background-color: #fc8b28;
}

.badge-danger {
  color: #ffffff;
  background-color: #df515f;
}
.badge-danger:hover {
  color: #ffffff;
  background-color: #df515f;
}

.badge-danger2 {
  color: #ffffff;
  background-color: #c55e97;
}
.badge-danger2:hover {
  color: #ffffff;
  background-color: #c55e97;
}
</style>
<style>
.tooltip .tooltip-inner {
  max-width: 500px !important;
  width: 300px !important;
  background: #fdfd96;
  text-align: left;
  color: black;
  white-space: pre-line;
  /* xuong hang cho tooltip */
}
</style>

<style scoped>
option {
  background: #fff;
}
.badge {
  /* padding: 1px 9px 2px; */
  font-size: 13.025px;
  font-weight: bold;
  white-space: nowrap;
  background-color: #999999;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  border-radius: 5px;
}
.badge-success {
  color: #383838;
  background-color: #c0f7fe;
}
.badge-success:hover {
  color: #383838;
  background-color: #c0f7fe;
}
.badge-primary {
  color: #383838;
  background-color: #ffffd7;
}
.badge-primary:hover {
  color: #383838;
  background-color: #ffffd7;
}

.badge-info {
  color: #383838;
  background-color: #ffe1c6;
}
.badge-info:hover {
  color: #383838;
  background-color: #ffe1c6;
}

.badge-warning {
  color: #ffffff;
  background-color: #fc8b28;
}
.badge-warning:hover {
  color: #ffffff;
  background-color: #fc8b28;
}

.badge-danger {
  color: #ffffff;
  background-color: #df515f;
}
.badge-danger:hover {
  color: #ffffff;
  background-color: #df515f;
}

.badge-danger2 {
  color: #ffffff;
  background-color: #c55e97;
}
.badge-danger2:hover {
  color: #ffffff;
  background-color: #c55e97;
}
.badge-danger3 {
  color: #ffffff;
  background-color: #c55e5e;
  font-size: inherit;
  font-weight: 400;
}
.badge-danger3:hover {
  color: #ffffff;
  background-color: #c55e5e;
  font-size: inherit;
}
.badge-info3 {
  color: #ffffff;
  background-color: #44852d;
  font-size: inherit;
  font-weight: 400;
}
.badge-info3:hover {
  color: #383838;
  background-color: #e2ffd7;
  font-size: inherit;
}

@media only screen and (max-width: 768px) {
  .cards {
    flex: 1 1 100%;
  }
  .card .icon {
    z-index: 0;
  }
  .card .num,
  .card h3 {
    z-index: 0;
  }
}
</style>
<style>
#cong_viec_vuecal .vuecal__header {
  background-color: #fff;
}
#booking_vuecal .vuecal__header {
  background-color: #fff;
}
</style>
